import { Vector2 } from './vector2';

export class Rectangle
{
    public x : number = 0;
    public y : number = 0;
    public width : number = 0;
    public height : number = 0;

    public get left() { return this.x; }
    public get top() { return this.y; }
    public get right() { return this.x + this.width; }
    public get bottom() { return this.y + this.height; }
    public get center() { return new Vector2(this.x + this.width / 2, this.y + this.height / 2); }
    public get centerX() { return this.center.x; }
    public get centerY() { return this.center.y; }

    public scaleAll(factor : number) : Rectangle
    {
        return new Rectangle(this.x * factor, this.y * factor, this.width * factor, this.height * factor);
    }

    public clone() : Rectangle
    {
        return new Rectangle(this.x, this.y, this.width, this.height);
    }

    constructor(x : number = 0, y : number = 0, width : number = 0, height : number = 0)
    {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            x : this.x,
            y : this.y,
            width : this.width,
            height : this.height
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var rect = new Rectangle();
        if(jsonData.x) { rect.x = jsonData.x; }
        if(jsonData.y) { rect.y = jsonData.y; }
        if(jsonData.width) { rect.width = jsonData.width; }
        if(jsonData.height) { rect.height = jsonData.height; }

        return rect;
    }
}